import { Box, Typography, Container, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import PageTabTitle from 'src/components/PageTabTitle';

// main content style
const MainContent = styled(Box)(
  () => `
      height: 100%;
      display: flex;
      flex: 1;
      overflow: auto;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  `
);

// Unauthorized component
function Unauthorized() {
  const [loading, setLoading] = useState(true);

  // Show loader for 1sec
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {/* Loader component */}
      {/* <Loader IsLoading={loading} /> */}
      {/* PageTitle component */}
      <PageTabTitle title="Unauthorized" />

      {/* Header component */}
      <Container maxWidth="lg" className="main-container">
        {/* <Header /> */}
      </Container>
      {!loading && (
        <>
          <MainContent>
            <Container maxWidth="md">
              <Box
                textAlign="center"
                sx={{
                  height: '90vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography variant="h2" sx={{ my: 2 }}>
                   The user has not been registered for this permit.
                </Typography>
              </Box>
            </Container>
          </MainContent>
        </>
      )}
    </>
  );
}

export default Unauthorized;
